// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._nd5l1sux{grid-area:1/1/2/3}._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._19pkidpf{margin-top:0}\n._2hwxv77o{margin-right:var(--ds-space-025,2px)}\n._otyridpf{margin-bottom:0}\n._syaz1gmx{color:var(--ds-text-disabled,#080f214a)}\n._syaz1rpy{color:var(--ds-text-subtlest,#6b6e76)}", ""]);
// Exports
module.exports = exports;
